var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdubg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 328,
    viewBox: "0 0 416 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 0H0V328H316.713L416 0Z",
    fill: "#FCE2BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdubg);
export default __webpack_public_path__ + "static/media/edubg.5cff0fb1a8afc5b93bf4757dd5de1fc1.svg";
export { ForwardRef as ReactComponent };